export default '@@RESIFT/CLEAR';
